module.exports = __webpack_public_path__ + "static/6305-woodrose-32-c2aea4711cc08a9b779b5543623680a1.jpg";